export enum NetworkType {
    MAINNET = 'MAINNET',
    TESTNET = 'TESTNET'
}

export enum NetworkName {
    COMMON = 'COMMON',
    NILE = 'NILE'
}
